import * as tslib_1 from "tslib";
import * as React from 'react';
import { BaseComponent } from '../../Utilities';
import { CalloutContent } from './CalloutContent';
import { Layer } from '../../Layer';
var Callout = /** @class */ (function (_super) {
    tslib_1.__extends(Callout, _super);
    function Callout(props) {
        return _super.call(this, props) || this;
    }
    Callout.prototype.render = function () {
        var content = React.createElement(CalloutContent, tslib_1.__assign({}, this.props));
        return this.props.doNotLayer ? content : React.createElement(Layer, null, content);
    };
    return Callout;
}(BaseComponent));
export { Callout };
//# sourceMappingURL=Callout.js.map